import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import { AssessmentList } from "../component/features/assessments/AssessmentList";
import { AssessmentAddFn } from "../component/features/assessments/AssessmentAddFn";
import AssessmentGrade from "../component/features/assessments/AssessmentGrading";
import Analytics from "../component/features/assessments/Analytics";

export class AssessmentRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/assessments"} component={AssessmentList} />
                <Route exact path={"/assessments/create"} component={AssessmentAddFn} />
                <Route exact path={"/assessments/edit/:assessmentid"} component={AssessmentAddFn} />
                <Route exact path={"/assessments/grade"} component={AssessmentGrade} />
                <Route exact path={"/assessments/analytics"} component={Analytics} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};